import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import TrashIcon from '@/assets/svg/trashcan.svg?react';
import { Button } from '@/components/buttons';
import { Text } from '@/components/typography';

import CompetitorProductAreas from './CompetitorProductAreas';
import { useAIVisibilitySettingsForm } from './useAIVisibilitySettingsForm';

type CompetitorCellProps = {
  competitorIndex: number;
  onDelete: () => void;
};

const CompetitorCell = ({ competitorIndex, onDelete }: CompetitorCellProps) => {
  const form = useAIVisibilitySettingsForm();

  return (
    <form.AppField name={`competitors[${competitorIndex}]`}>
      {(competitorField) => {
        const competitor = competitorField.state.value;

        return (
          <form.Subscribe selector={(state) => state.isSubmitting}>
            {(isSubmitting) => (
              <div
                role="group"
                aria-label={competitor.name}
                className="relative rounded-2xl bg-gray-100 px-5 py-4"
              >
                <Button
                  variant="ghost"
                  shape="square"
                  danger
                  size="icon"
                  className="absolute top-3 right-3"
                  aria-label={t`Delete ${competitor.name}`}
                  disabled={isSubmitting}
                  onClick={onDelete}
                >
                  <TrashIcon />
                </Button>
                <div className="pr-10">
                  <div className="flex items-baseline gap-2">
                    <Text variant="subhead" weight="semi-bold">
                      {competitor.name}
                    </Text>
                    <Text variant="caption1" color="grey">
                      {competitor.domain}
                    </Text>
                  </div>
                  <form.Subscribe selector={(state) => state.values.brandProductAreas.length > 0}>
                    {(hasBrandProductAreas) =>
                      hasBrandProductAreas ? (
                        <Text variant="body2" color="grey" className="mt-1 block">
                          <Trans>Compare in these product areas.</Trans>
                        </Text>
                      ) : null
                    }
                  </form.Subscribe>
                </div>
                <CompetitorProductAreas competitorIndex={competitorIndex} />
              </div>
            )}
          </form.Subscribe>
        );
      }}
    </form.AppField>
  );
};

export default CompetitorCell;
